import { GET_DEADLINE, GET_USERDATA, GROUP_CHANGE, PROFILE_CHANGE } from '../actions/types';

const INITIAL_STATE = {};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_USERDATA:
      return { ...state, ...action.payload };
    case GET_DEADLINE:
      return { ...state, ...action.payload };
    case PROFILE_CHANGE:
      return { ...state, [action.target]: action.payload };
    case GROUP_CHANGE:
      return { ...state, groups: action.payload };
    default:
      return state;
  }
};
